export default "__VITE_ASSET__BIDHFedd__"